import { Component, Injector, OnInit, ViewChild, Renderer2, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { GridComponent } from '@progress/kendo-angular-grid';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { NgForm } from '@angular/forms';
import { MarkupsService } from './markups.service';
import { finalize } from 'rxjs/operators';
const hasClass = (el, className) => new RegExp(className).test(el.className);
const isChildOf = (el, className) => {
  while (el && el.parentElement) {
    if (hasClass(el.parentElement, className)) {
      return true;
    }
    el = el.parentElement;
  }
  return false;
};

@Component({
  selector: 'app-markups-list',
  templateUrl: './markups-list.component.html',
  styleUrls: ['./markups-list.component.scss']
})
export class MarkupsListComponent extends AppComponentBase implements OnInit {
  @ViewChild('grid', { static: true }) private grid: GridComponent;
  @ViewChild('markupsListForm', { static: true }) markupsListForm: NgForm;
  @Output() emitMarkups: EventEmitter<any> = new EventEmitter<any>();
  @Input() set accountDetailsParams(data: any) {
    if (data.id) {
      this.accountDetails = data;
      this.getMarkupsList();
    }
  }

  accountDetails: any;
  editedRowIndex: any;
  gridItems: any = {
    data: [],
    total: 0
  };
  isGridDataValid = true;
  isFormLoading = false;

  constructor(
    injector: Injector,
    private renderer: Renderer2,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    private markupsService: MarkupsService
  ) {
    super(injector);
    this.renderer.listen(
      'document',
      'click',
      ({ target }) => {
        if (!isChildOf(target, 'markupsGrid')) {
          if (this.markupsListForm.valid) {
            this.grid.closeRow(this.editedRowIndex);
            this.isGridDataValid = true;
          } else {
            this.isGridDataValid = false;
          }
        }
      });
  }

  ngOnInit() {
  }

  getMarkupsList() {
    const searchQuery = `AccountId=${this.accountDetails.id}`;
    this.markupsService.getMarkupsList(searchQuery).subscribe((response: any) => {
      if (response.isSuccess) {
        this.gridItems = {
          data: response.data,
          total: response.data.length
        };
        this.emitMarkups.emit();
      } else {
        this.toastr.error(response.errors, 'Error!');
      }
    });
  }

  onCellClickHandler({ sender, rowIndex }, grid: any) {
    if (this.markupsListForm.valid) {
      grid.closeRow(this.editedRowIndex);
      this.editedRowIndex = rowIndex;
      sender.editRow(rowIndex);
      this.isGridDataValid = true;
    } else {
      this.isGridDataValid = false;
    }
  }

  onSaveMarkups() {
    this.isFormLoading = true;
    const markupsData = {
      accountMarkups: this.gridItems.data
    };
    this.markupsService.updateMarkupsList(markupsData)
    .pipe(finalize(() => (this.isFormLoading = false)))
    .subscribe((response: any) => {
      this.isFormLoading = false;
      if (response.isSuccess) {
        this.toastr.success(response.errors || 'Updated Successfully');
        this.getMarkupsList();
      } else {
        this.toastr.error(response.errors || 'Something Went wrong, Please Re-try.', 'Error!');
      }
    });
  }

  onMarkupPercentageChange(dataItem: any, event: any) {
    dataItem.markupPercentage = event ? (+event) : 0;
    this.calculateMarginPercentage(dataItem);
  }

  calculateMarginPercentage(dataItem: any) {
    const cost = 1;
    const markupPercentage = dataItem.markupPercentage ? (+dataItem.markupPercentage) : 0;
    if (cost > 0) {
      const marginPerValue = ((cost + (cost * markupPercentage / 100) - cost) / (cost + (cost * markupPercentage / 100))) * 100;
      dataItem.marginPercentage = marginPerValue.toFixed(2);
    }
  }

  onMarginPercentageChange(dataItem: any, event: any) {
    dataItem.marginPercentage = event ? (+event) : 0;
    this.calculateMarkupPercentage(dataItem);
  }

  calculateMarkupPercentage(dataItem: any) {
    const value = Math.abs(100 - dataItem.marginPercentage);
    const markupPercentage = Math.round(((100 / value) * 100 - 100));
    dataItem.markupPercentage = markupPercentage.toFixed(2);
  }

  onCancelChanges() {
    this.getMarkupsList();
  }

}
